import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Truck, Lock, Loader2 } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/login", { email, password });
      toast.success("Welcome back.");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-movewave-paper flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2 mb-8" data-testid="brand-logo">
          <div className="w-9 h-9 bg-movewave-blue flex items-center justify-center">
            <Truck className="w-5 h-5 text-white" strokeWidth={2.5} />
          </div>
          <span className="font-display font-black text-2xl tracking-tight">
            VanLines <span className="text-movewave-blue">Scout</span>
          </span>
        </Link>

        <form
          onSubmit={submit}
          className="bg-white border-2 border-movewave-ink p-8 shadow-[10px_10px_0_#002FA7]"
          data-testid="admin-login-form"
        >
          <div className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-bold text-movewave-blue mb-2">
            <Lock className="w-3.5 h-3.5" /> Partner portal
          </div>
          <h1 className="font-display font-black text-3xl tracking-tight mb-1">Sign in</h1>
          <p className="text-gray-600 text-sm mb-6">Access the leads dashboard.</p>

          <label className="block mb-4">
            <span className="text-xs font-bold uppercase tracking-wider text-gray-800 mb-2 block">Email</span>
            <Input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@vanlinescout.com"
              className="h-12 text-base font-medium border-2 border-gray-200 focus:border-movewave-blue focus-visible:ring-0 rounded-none bg-white"
              data-testid="login-email-input"
            />
          </label>

          <label className="block mb-6">
            <span className="text-xs font-bold uppercase tracking-wider text-gray-800 mb-2 block">Password</span>
            <Input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className="h-12 text-base font-medium border-2 border-gray-200 focus:border-movewave-blue focus-visible:ring-0 rounded-none bg-white"
              data-testid="login-password-input"
            />
          </label>

          <Button
            type="submit"
            disabled={loading}
            className="w-full bg-movewave-ink hover:bg-black text-white font-bold uppercase tracking-wider rounded-none h-12 btn-brut"
            data-testid="login-submit-btn"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign in"}
          </Button>

          <p className="text-xs text-gray-500 mt-6 text-center">
            Need access? Contact partnerships@vanlinesscout.com
          </p>
        </form>
      </div>
    </div>
  );
}
